import React, {Component} from 'react';
import { Container, Tab } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';


// TODO: this is not the most elegant routing solution
// TOOD: realtive paths e.g. ignore the /admin prefix
class Tabs extends Component {
  constructor(props) {
    super();
  }

  getActiveIndexFromRoute = ({pathname}) => {
    return Math.max(this.props.panes.findIndex(({path}) => { return path === pathname; }), 0);
  };

  handleTabChange = (e, {activeIndex}) => {
    this.props.history.push(this.props.panes[activeIndex].path);
  };
  
  render () {
    return (
      <Container>
        <Tab
          defaultActiveIndex={this.getActiveIndexFromRoute(this.props.location)}
          onTabChange={this.handleTabChange}
          panes={this.props.panes.map(({title, path, contents}) => {
            return {
              menuItem: title,
              render: () =>  <Tab.Pane>{contents}</Tab.Pane>
            };
          })} />
      </Container>
    );
  }
};

export default withRouter(Tabs);



// WEBPACK FOOTER //
// ./src/private/common/components/Tabs/index.js